import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-942f4e8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { style: {"height":"90vh","background-color":"white"} }
const _hoisted_3 = { style: {"height":"0.5vh"} }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-mx-1" }
const _hoisted_8 = { class: "p-mx-1" }
const _hoisted_9 = { class: "p-mx-1" }
const _hoisted_10 = { class: "p-mx-1" }
const _hoisted_11 = { class: "p-grid p-m-0" }
const _hoisted_12 = { class: "p-col-9" }
const _hoisted_13 = {
  class: "p-fluid",
  style: {"height":"8vh"}
}
const _hoisted_14 = { class: "p-mr-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_16 = { class: "pull-right" }
const _hoisted_17 = { class: "p-mr-1" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" REF : ")
const _hoisted_19 = { class: "pull-right" }
const _hoisted_20 = { class: "p-mx-1" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" EXPIRY DATE : ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" GENERIC : ")
const _hoisted_23 = { class: "pull-right" }
const _hoisted_24 = { class: "p-mr-1" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" BATCH NO : ")
const _hoisted_26 = { class: "pull-right" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Total Units : ")
const _hoisted_28 = { class: "pull-right" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Unit Price : ")
const _hoisted_31 = { class: "pull-right" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Unit Purchase Price : ")
const _hoisted_34 = { class: "pull-right" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Brand Name : ")
const _hoisted_36 = { class: "pull-right" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Item Location : ")
const _hoisted_38 = { class: "pull-right" }
const _hoisted_39 = {
  class: "pos-table",
  style: {"height":"72.7vh"}
}
const _hoisted_40 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_41 = { class: "pos-heading" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"18rem"} }, "Item", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Batch", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit", -1))
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { style: {"width":"5rem"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Disc (%)", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_50 = { class: "table-row" }
const _hoisted_51 = { class: "p-pt-2" }
const _hoisted_52 = { class: "p-pt-2" }
const _hoisted_53 = { class: "p-inputgroup" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "p-inputgroup" }
const _hoisted_56 = { class: "p-pt-2" }
const _hoisted_57 = { class: "p-pt-2" }
const _hoisted_58 = { class: "p-pt-2" }
const _hoisted_59 = { class: "p-inputgroup" }
const _hoisted_60 = { class: "p-pt-2" }
const _hoisted_61 = { class: "p-text-center" }
const _hoisted_62 = { class: "item-detail-row" }
const _hoisted_63 = ["colspan"]
const _hoisted_64 = { class: "p-mr-1" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_66 = { class: "p-mx-1" }
const _hoisted_67 = {
  key: 0,
  class: "p-mx-1"
}
const _hoisted_68 = {
  key: 1,
  class: "p-mx-1"
}
const _hoisted_69 = {
  key: 2,
  class: "p-mx-1"
}
const _hoisted_70 = { class: "p-mx-1" }
const _hoisted_71 = {
  class: "p-col-3",
  style: {"border-left":"1px solid #eee"}
}
const _hoisted_72 = { class: "p-fluid" }
const _hoisted_73 = { class: "p-field" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customername" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Customer Name ")
], -1))
const _hoisted_75 = { key: 1 }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_77 = { class: "pull-right" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_79 = { class: "pull-right" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_81 = { class: "pull-right" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_83 = { class: "pull-right" }
const _hoisted_84 = { key: 2 }
const _hoisted_85 = { class: "p-error" }
const _hoisted_86 = {
  key: 3,
  class: "p-error"
}
const _hoisted_87 = { class: "p-field" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactnumber" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Customer Contact Number ")
], -1))
const _hoisted_89 = { key: 1 }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_91 = { class: "pull-right" }
const _hoisted_92 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_93 = { class: "pull-right" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_95 = { class: "pull-right" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_97 = { class: "pull-right" }
const _hoisted_98 = { key: 2 }
const _hoisted_99 = { class: "p-error" }
const _hoisted_100 = {
  key: 3,
  class: "p-error"
}
const _hoisted_101 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_102 = { class: "p-field" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Choose Transfer Store ")
], -1))
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { class: "p-error" }
const _hoisted_106 = {
  key: 1,
  class: "p-error"
}
const _hoisted_107 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_108 = { class: "p-field" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Patient Description ")
], -1))
const _hoisted_110 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_111 = { class: "p-field" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Doctor Description ")
], -1))
const _hoisted_113 = { class: "p-fluid" }
const _hoisted_114 = { class: "p-field" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"12px","color":"#11467e"},
    class: "pi pi-file"
  }),
  /*#__PURE__*/_createTextVNode(" Receipt Description ")
], -1))
const _hoisted_116 = { class: "p-fluid" }
const _hoisted_117 = { class: "p-field" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Taxes Includes", -1))
const _hoisted_119 = { class: "p-inputgroup" }
const _hoisted_120 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_121 = { class: "p-mx-2" }
const _hoisted_122 = {
  key: 1,
  class: "p-inputgroup-addon"
}
const _hoisted_123 = { class: "p-mx-2" }
const _hoisted_124 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_125 = { class: "p-mx-2" }
const _hoisted_126 = { class: "p-fluid flex-container" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Invoice Discount", -1))
const _hoisted_128 = { class: "flex-row" }
const _hoisted_129 = ["value"]
const _hoisted_130 = { class: "flex-span" }
const _hoisted_131 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_132 = { class: "set-bottom-amt p-col" }
const _hoisted_133 = /*#__PURE__*/_createTextVNode("Product QTY ")
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_135 = { class: "set-bottom-amt p-col" }
const _hoisted_136 = /*#__PURE__*/_createTextVNode("Total Gross ")
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_138 = { class: "set-bottom-amt p-col" }
const _hoisted_139 = /*#__PURE__*/_createTextVNode("Total Disc ")
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_141 = {
  key: 0,
  class: "set-bottom-amt p-col"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_143 = {
  key: 1,
  class: "set-bottom-amt p-col"
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_145 = {
  key: 2,
  class: "set-bottom-amt p-col"
}
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_147 = { class: "set-bottom-amt p-col" }
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_150 = { class: "confirmation-content" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle p-mr-3",
    style: {"font-size":"2rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Are you sure to delete the profile name? Any changes you make to profile name won't be effective in actual profile")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_fullscreen = _resolveComponent("fullscreen")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!
  const _component_ProfilerDialog = _resolveComponent("ProfilerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.progressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_fullscreen, {
      fullscreen: _ctx.screenState.fullscreen,
      "onUpdate:fullscreen": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.screenState.fullscreen) = $event)),
      teleport: _ctx.screenState.teleport,
      "page-only": _ctx.screenState.pageOnly
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.progressBar)
                ? (_openBlock(), _createBlock(_component_ProgressBar, {
                    key: 0,
                    mode: "indeterminate",
                    style: {"height":"0.2em"}
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
              start: _withCtx(() => [
                _createElementVNode("h5", _hoisted_4, [
                  _createElementVNode("b", null, [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
                  ])
                ])
              ]),
              end: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Dropdown, {
                    style: {"width":"10rem"},
                    modelValue: _ctx.item.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.type) = $event)),
                    options: _ctx.modeList,
                    optionLabel: "label",
                    optionValue: "value",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shiftPos()))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-plus",
                    label: "New Customer",
                    class: "p-button-success",
                    onClick: _ctx.openProfileDialog
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-times",
                    label: "Clear Screen",
                    class: "p-button-info",
                    onClick: _ctx.clearAllManually
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-power-off",
                    label: "Cashier Logout",
                    class: "p-button-danger",
                    onClick: _ctx.logoutCashier
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (!_ctx.screenState.fullscreen)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-window-maximize",
                        class: "p-button-warning",
                        onClick: _ctx.toggleScreen
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.screenState.fullscreen)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "pi pi-window-minimize",
                        class: "p-button-warning",
                        onClick: _ctx.toggleScreen
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_AutoComplete, {
                    delay: 500,
                    minLength: 3,
                    onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveItem($event))),
                    scrollHeight: "500px",
                    modelValue: _ctx.itemScanBox,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemScanBox) = $event)),
                    suggestions: _ctx.itemList,
                    autoHighlight: true,
                    placeholder: " SCAN BARCODE OR SEARCH ITEMS",
                    onComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchItem($event))),
                    onKeydown: [
                      _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (
                                    _ctx.focusNext(
                                        'item-unit-' + _ctx.getTopMostItem(),
                                        $event,
                                        'search_bar'
                                    )
                                ), ["prevent"]), ["down"])),
                      _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (
                                    _ctx.focusNext('custName', $event, 'search_bar')
                                ), ["prevent"]), ["right"])),
                      _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.openProfileDialog()), ["prevent"]), ["insert"])),
                      _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.logoutCashier()), ["prevent"]), ["end"]))
                    ],
                    dropdown: false,
                    id: "pos-input",
                    autoFocus: ""
                  }, {
                    item: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("b", _hoisted_16, _toDisplayString(slotProps.item.product_name.toUpperCase()), 1)
                        ]),
                        _withDirectives(_createElementVNode("span", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("b", _hoisted_19, _toDisplayString(slotProps.item.reference), 1)
                        ], 512), [
                          [_vShow, slotProps.item.reference]
                        ]),
                        _createElementVNode("span", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("b", {
                            class: _normalizeClass([
                                                    'pull-right',
                                                    _ctx.isExpiryDateCritical(
                                                        slotProps.item
                                                    ),
                                                ])
                          }, _toDisplayString(_ctx.formatExpiryDate(
                                                        slotProps.item
                                                            .expiry_date
                                                    )), 3)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _hoisted_22,
                          _createElementVNode("b", _hoisted_23, _toDisplayString(slotProps.item.generic_name.toUpperCase()), 1)
                        ]),
                        _createElementVNode("span", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("b", _hoisted_26, _toDisplayString(slotProps.item.batch_no), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, [
                          _hoisted_27,
                          _createElementVNode("b", _hoisted_28, _toDisplayString(Number(
                                                        slotProps.item.qty
                                                    ).toFixed(0)), 1)
                        ]),
                        (_ctx.item.type != 'TRN')
                          ? (_openBlock(), _createElementBlock("small", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("b", _hoisted_31, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.sale_price), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("small", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("b", _hoisted_34, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item
                                                        .purchase_price), 1)
                            ])),
                        _createElementVNode("small", null, [
                          _hoisted_35,
                          _createElementVNode("b", _hoisted_36, _toDisplayString(slotProps.item.bName), 1)
                        ]),
                        _createElementVNode("small", null, [
                          _hoisted_37,
                          _createElementVNode("b", _hoisted_38, _toDisplayString(slotProps.item
                                                        .product_location), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "suggestions"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("table", _hoisted_40, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_41, [
                        _hoisted_42,
                        _hoisted_43,
                        _hoisted_44,
                        (_ctx.item.type == 'TRN')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_45, " Gift Unit "))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_46, " Price (" + _toDisplayString(_ctx.currency) + ") ", 1),
                        _hoisted_47,
                        _hoisted_48,
                        _createElementVNode("th", null, "Subtotal (" + _toDisplayString(_ctx.currency) + ")", 1),
                        _hoisted_49
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedItemList
                                            .slice()
                                            .reverse(), (savedItem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: savedItem.id
                        }, [
                          _createElementVNode("tr", _hoisted_50, [
                            _createElementVNode("td", _hoisted_51, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.limitString(
                                                            savedItem.productName
                                                        )), 1)
                            ]),
                            _createElementVNode("td", _hoisted_52, [
                              _createElementVNode("small", null, _toDisplayString(savedItem.batchNo), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_Button, {
                                  icon: "pi pi-plus",
                                  class: "p-button-success p-p-0",
                                  onClick: ($event: any) => (
                                                            _ctx.adjustQty(
                                                                'add',
                                                                savedItem
                                                            )
                                                        )
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_InputText, {
                                  style: {"width":"2rem","height":"35px"},
                                  modelValue: 
                                                            savedItem.unit
                                                        ,
                                  "onUpdate:modelValue": ($event: any) => ((
                                                            savedItem.unit
                                                        ) = $event),
                                  modelModifiers: { number: true },
                                  id: 
                                                            'item-unit-' +
                                                            savedItem.rowID
                                                        ,
                                  onKeydown: [
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-unit-' +
                                                                    (savedItem.rowID +
                                                                        1),
                                                                $event,
                                                                'back_to_item_search'
                                                            )
                                                        ), ["prevent"]), ["up"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-unit-' +
                                                                    (savedItem.rowID -
                                                                        1),
                                                                $event,
                                                                null
                                                            )
                                                        ), ["prevent"]), ["down"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-disc-' +
                                                                    (savedItem.rowID +
                                                                        1),
                                                                $event,
                                                                null
                                                            )
                                                        ), ["prevent"]), ["left"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-disc-' +
                                                                    savedItem.rowID,
                                                                $event,
                                                                null
                                                            )
                                                        ), ["prevent"]), ["right"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.clearListItem(
                                                                savedItem
                                                            )
                                                        ), ["prevent"]), ["-"])
                                  ],
                                  class: _normalizeClass(["p-p-0 p-m-0", {
                                                            'is-invalid':
                                                                savedItem.unit ==
                                                                0,
                                                        }]),
                                  onInput: ($event: any) => (
                                                            _ctx.validateUnit(
                                                                savedItem,
                                                                $event
                                                            )
                                                        )
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onKeydown", "onInput", "class"]),
                                _createVNode(_component_Button, {
                                  icon: "pi pi-minus",
                                  class: "p-button-warning p-p-0",
                                  onClick: ($event: any) => (
                                                            _ctx.adjustQty(
                                                                'minus',
                                                                savedItem
                                                            )
                                                        )
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            (_ctx.item.type == 'TRN')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createVNode(_component_Button, {
                                      icon: "pi pi-plus",
                                      class: "p-button-success p-p-0",
                                      onClick: ($event: any) => (
                                                            _ctx.adjustFreeQty(
                                                                'add',
                                                                savedItem
                                                            )
                                                        )
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_InputNumber, {
                                      useGrouping: false,
                                      style: {"width":"2rem","height":"35px"},
                                      min: 1,
                                      modelValue: 
                                                            savedItem.freeUnit
                                                        ,
                                      "onUpdate:modelValue": ($event: any) => ((
                                                            savedItem.freeUnit
                                                        ) = $event),
                                      class: "p-p-0 p-m-0"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_Button, {
                                      icon: "pi pi-minus",
                                      class: "p-button-warning p-p-0",
                                      onClick: ($event: any) => (
                                                            _ctx.adjustFreeQty(
                                                                'minus',
                                                                savedItem
                                                            )
                                                        )
                                    }, null, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(
                                                        savedItem.sellingPrice
                                                    )), 1),
                            _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.formatExpiryDate(
                                                        savedItem.expiryDate
                                                    )), 1),
                            _createElementVNode("td", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_Button, {
                                  icon: "pi pi-plus",
                                  class: "p-button-success p-p-0",
                                  onClick: ($event: any) => (
                                                            _ctx.adjustDisc(
                                                                'add',
                                                                savedItem
                                                            )
                                                        )
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_InputText, {
                                  useGrouping: false,
                                  style: {"width":"2rem","height":"35px"},
                                  onInput: ($event: any) => (
                                                            _ctx.validateDisc(
                                                                savedItem,
                                                                $event
                                                            )
                                                        ),
                                  id: 
                                                            'item-disc-' +
                                                            savedItem.rowID
                                                        ,
                                  onKeydown: [
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-disc-' +
                                                                    (savedItem.rowID +
                                                                        1),
                                                                $event,
                                                                'back_to_item_search'
                                                            )
                                                        ), ["prevent"]), ["up"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-disc-' +
                                                                    (savedItem.rowID -
                                                                        1),
                                                                $event,
                                                                null
                                                            )
                                                        ), ["prevent"]), ["down"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-unit-' +
                                                                    savedItem.rowID,
                                                                $event,
                                                                null
                                                            )
                                                        ), ["prevent"]), ["left"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.focusNext(
                                                                'item-unit-' +
                                                                    (savedItem.rowID -
                                                                        1),
                                                                $event,
                                                                'back_to_item_customer'
                                                            )
                                                        ), ["prevent"]), ["right"]),
                                    _withKeys(_withModifiers(($event: any) => (
                                                            _ctx.clearListItem(
                                                                savedItem
                                                            )
                                                        ), ["prevent"]), ["-"])
                                  ],
                                  modelValue: 
                                                            savedItem.itemDisc
                                                        ,
                                  "onUpdate:modelValue": ($event: any) => ((
                                                            savedItem.itemDisc
                                                        ) = $event),
                                  class: "p-p-0 p-m-0"
                                }, null, 8, ["onInput", "id", "onKeydown", "modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_Button, {
                                  icon: "pi pi-minus",
                                  class: "p-button-warning p-p-0",
                                  onClick: ($event: any) => (
                                                            _ctx.adjustDisc(
                                                                'minus',
                                                                savedItem
                                                            )
                                                        )
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.getTheSubtotal(savedItem)), 1),
                            _createElementVNode("td", _hoisted_61, [
                              _createVNode(_component_Button, {
                                icon: "pi pi-minus",
                                class: "p-button-danger p-p-1",
                                onClick: ($event: any) => (
                                                        _ctx.clearListItem(savedItem)
                                                    )
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("tr", _hoisted_62, [
                            _createElementVNode("td", {
                              colspan: 
                                                    _ctx.item.type == 'TRN' ? 9 : 8
                                                
                            }, [
                              _createElementVNode("span", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("span", null, _toDisplayString(_ctx.limitString(
                                                                savedItem.generic
                                                            )), 1)
                              ]),
                              _createElementVNode("span", _hoisted_66, " BATCH NO : " + _toDisplayString(savedItem.batchNo), 1),
                              (_ctx.taxNames[0].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.taxNames[0].taxName) + " : " + _toDisplayString(_ctx.fixDigits(
                                                            savedItem.tax1
                                                        )) + "% ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.taxNames[1].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.taxNames[1].taxName) + " : " + _toDisplayString(_ctx.fixDigits(
                                                            savedItem.tax2
                                                        )) + "% ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.taxNames[2].show)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.taxNames[2].taxName) + " : " + _toDisplayString(_ctx.fixDigits(
                                                            savedItem.tax3
                                                        )) + "% ", 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_70, " TOTAL SELLING UNITS : " + _toDisplayString(Number(
                                                            savedItem.totalUnit
                                                        ).toFixed(0)), 1)
                            ], 8, _hoisted_63)
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    (!_ctx.delayedChippedTel)
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 0,
                          modelValue: _ctx.state.chippedProfile,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.chippedProfile) = $event)),
                          readonly: _ctx.state.chippedProfile.length > 0,
                          onRemove: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeProfile($event))),
                          class: "p-chips-input-token"
                        }, null, 8, ["modelValue", "readonly"]))
                      : _createCommentVNode("", true),
                    (_ctx.delayedChippedTel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createVNode(_component_AutoComplete, {
                            delay: 200,
                            minLength: 3,
                            onItemSelect: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveProfile($event))),
                            scrollHeight: "500px",
                            modelValue: _ctx.v$.selectedProfile.$model,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                            suggestions: _ctx.profilerList,
                            placeholder: "Search Profile",
                            id: "custName",
                            onKeydown: [
                              _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext('pos-input', $event, null)
                                        ), ["prevent"]), ["up"])),
                              _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext('pos-input', $event, null)
                                        ), ["prevent"]), ["left"])),
                              _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext('custPhone', $event, null)
                                        ), ["prevent"]), ["down"]))
                            ],
                            onComplete: _cache[16] || (_cache[16] = ($event: any) => (_ctx.searchProfiler($event))),
                            dropdown: false,
                            autoFocus: ""
                          }, {
                            item: _withCtx((slotProps) => [
                              _createElementVNode("div", null, [
                                _hoisted_76,
                                _createElementVNode("b", _hoisted_77, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_78,
                                _createElementVNode("span", _hoisted_79, _toDisplayString(slotProps.item
                                                            .email_address), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_80,
                                _createElementVNode("span", _hoisted_81, _toDisplayString(slotProps.item
                                                            .contact_no), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_82,
                                _createElementVNode("span", _hoisted_83, _toDisplayString(slotProps.item
                                                            .account_type), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "suggestions"])
                        ]))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.v$.selectedProfile.$error && _ctx.submitted
                                    )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$
                                            .selectedProfile.$errors, (error, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              id: "p-error",
                              key: index
                            }, [
                              _createElementVNode("small", _hoisted_85, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                                        (_ctx.v$.selectedProfile.$invalid &&
                                            _ctx.submitted) ||
                                        _ctx.v$.selectedProfile.$pending.$response
                                    )
                        ? (_openBlock(), _createElementBlock("small", _hoisted_86, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                                            "Value",
                                            "Profile"
                                        )), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    (!_ctx.delayedChippedTel)
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 0,
                          modelValue: _ctx.state.chippedTel,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.chippedTel) = $event)),
                          readonly: _ctx.state.chippedTel.length > 0,
                          onRemove: _cache[18] || (_cache[18] = ($event: any) => (_ctx.removeProfile($event))),
                          class: "p-chips-input-token"
                        }, null, 8, ["modelValue", "readonly"]))
                      : _createCommentVNode("", true),
                    (_ctx.delayedChippedTel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          _createVNode(_component_AutoComplete, {
                            delay: 1000,
                            minLength: 3,
                            maxLength: 10,
                            onItemSelect: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveProfile($event))),
                            scrollHeight: "500px",
                            modelValue: _ctx.state.customerTel,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.customerTel) = $event)),
                            suggestions: _ctx.profilerList,
                            placeholder: "Search Profile from Mobile, Ex: 077xxxxxxx",
                            onComplete: _cache[21] || (_cache[21] = ($event: any) => (_ctx.searchProfiler($event))),
                            dropdown: false,
                            id: "custPhone",
                            onKeydown: [
                              _cache[22] || (_cache[22] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext('custName', $event, null)
                                        ), ["prevent"]), ["up"])),
                              _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext(
                                                'item-disc-' +
                                                    _ctx.getBottomMostItem(),
                                                $event,
                                                null
                                            )
                                        ), ["prevent"]), ["left"])),
                              _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext('custDesc', $event, null)
                                        ), ["prevent"]), ["down"]))
                            ],
                            autoFocus: ""
                          }, {
                            item: _withCtx((slotProps) => [
                              _createElementVNode("div", null, [
                                _hoisted_90,
                                _createElementVNode("b", _hoisted_91, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_92,
                                _createElementVNode("span", _hoisted_93, _toDisplayString(slotProps.item
                                                            .email_address), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_94,
                                _createElementVNode("span", _hoisted_95, _toDisplayString(slotProps.item
                                                            .contact_no), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_96,
                                _createElementVNode("span", _hoisted_97, _toDisplayString(slotProps.item
                                                            .account_type), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "suggestions"])
                        ]))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.v$.selectedProfile.$error && _ctx.submitted
                                    )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_98, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$
                                            .selectedProfile.$errors, (error, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              id: "p-error",
                              key: index
                            }, [
                              _createElementVNode("small", _hoisted_99, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : (
                                        (_ctx.v$.selectedProfile.$invalid &&
                                            _ctx.submitted) ||
                                        _ctx.v$.selectedProfile.$pending.$response
                                    )
                        ? (_openBlock(), _createElementBlock("small", _hoisted_100, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                                            "Value",
                                            "Profile"
                                        )), 1))
                        : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.item.type == 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.v$.transferStoreID.$model,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.v$.transferStoreID.$model) = $event)),
                          filter: true,
                          options: _ctx.storeList,
                          optionLabel: "name",
                          optionValue: "id",
                          placeholder: "Search Store"
                        }, null, 8, ["modelValue", "options"]),
                        (
                                        _ctx.v$.transferStoreID.$error && _ctx.submitted
                                    )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_104, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$
                                            .transferStoreID.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  id: "p-error",
                                  key: index
                                }, [
                                  _createElementVNode("small", _hoisted_105, _toDisplayString(error.$message), 1)
                                ]))
                              }), 128))
                            ]))
                          : (
                                        (_ctx.v$.transferStoreID.$invalid &&
                                            _ctx.submitted) ||
                                        _ctx.v$.transferStoreID.$pending.$response
                                    )
                            ? (_openBlock(), _createElementBlock("small", _hoisted_106, _toDisplayString(_ctx.v$.transferStoreID.required.$message.replace(
                                            "Value",
                                            "Transfer Store"
                                        )), 1))
                            : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type != 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.item.patientDetails,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.item.patientDetails) = $event)),
                          id: "custDesc",
                          onKeydown: [
                            _cache[27] || (_cache[27] = _withKeys(_withModifiers(($event: any) => (
                                        _ctx.focusNext('custPhone', $event, null)
                                    ), ["prevent"]), ["up"])),
                            _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (
                                        _ctx.focusNext('custDocDesc', $event, null)
                                    ), ["prevent"]), ["down"]))
                          ],
                          placeholder: "e.g Patient Jhon Doe"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type != 'TRN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.item.doctorDetails,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.item.doctorDetails) = $event)),
                          id: "custDocDesc",
                          onKeydown: [
                            _cache[30] || (_cache[30] = _withKeys(_withModifiers(($event: any) => (
                                        _ctx.focusNext('custDesc', $event, null)
                                    ), ["prevent"]), ["up"])),
                            _cache[31] || (_cache[31] = _withKeys(_withModifiers(($event: any) => (
                                        _ctx.focusNext(
                                            'custReceiptDesc',
                                            $event,
                                            null
                                        )
                                    ), ["prevent"]), ["down"]))
                          ],
                          placeholder: "e.g Dr Jhon Doe"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.item.description,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.item.description) = $event)),
                      id: "custReceiptDesc",
                      onKeydown: [
                        _cache[33] || (_cache[33] = _withKeys(_withModifiers(($event: any) => (
                                        _ctx.focusNext('custDesc', $event, null)
                                    ), ["prevent"]), ["up"])),
                        _cache[34] || (_cache[34] = _withKeys(_withModifiers(($event: any) => (
                                        _ctx.focusNext(
                                            'custInvoiceDisc',
                                            $event,
                                            null
                                        )
                                    ), ["prevent"]), ["down"]))
                      ]
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_116, [
                  _createElementVNode("div", _hoisted_117, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, [
                      (_ctx.taxNames[0].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                            _createVNode(_component_Checkbox, {
                              disabled: 
                                                _ctx.taxNames[0].optionalReq ==
                                                'Required'
                                            ,
                              modelValue: _ctx.selectedTaxes.tax1,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.selectedTaxes.tax1) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.taxNames[0].taxName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.taxNames[1].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_122, [
                            _createVNode(_component_Checkbox, {
                              disabled: 
                                                _ctx.taxNames[1].optionalReq ==
                                                'Required'
                                            ,
                              modelValue: _ctx.selectedTaxes.tax2,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.selectedTaxes.tax2) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.taxNames[1].taxName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.taxNames[2].show)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_124, [
                            _createVNode(_component_Checkbox, {
                              disabled: 
                                                _ctx.taxNames[2].optionalReq ==
                                                'Required'
                                            ,
                              modelValue: _ctx.selectedTaxes.tax3,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.selectedTaxes.tax3) = $event)),
                              binary: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.taxNames[2].taxName), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _hoisted_127,
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("span", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: "p-inputgroup-addon apply-style-unit",
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.discType) = $event)),
                        onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.changeInvoiceDiscount && _ctx.changeInvoiceDiscount(...args))),
                        id: "custInvoiceDisc",
                        onKeydown: [
                          _cache[40] || (_cache[40] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext(
                                                'custReceiptDesc',
                                                $event,
                                                null
                                            )
                                        ), ["prevent"]), ["up"])),
                          _cache[41] || (_cache[41] = _withKeys(_withModifiers(($event: any) => (
                                            _ctx.focusNext(
                                                'custInvoiceDiscVal',
                                                $event,
                                                null
                                            )
                                        ), ["prevent"]), ["down"]))
                        ]
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discountType, (t) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: t.key,
                            value: t.name
                          }, _toDisplayString(t.name), 9, _hoisted_129))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.discType]
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_130, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.invoiceDiscount,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.invoiceDiscount) = $event)),
                        onInput: _ctx.totalDiscAmount,
                        placeholder: "Discount",
                        id: "custInvoiceDiscVal",
                        max: 
                                            _ctx.discType == 'Flat'
                                                ? _ctx.totalGross -
                                                  this.itemDiscAmount
                                                : 100
                                        
                      }, null, 8, ["modelValue", "onInput", "max"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_131, [
            _createVNode(_component_Button, {
              class: "p-col p-button-success b-style",
              icon: "pi pi-home",
              label: "HOME",
              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.redirectHome()))
            }),
            _createElementVNode("span", _hoisted_132, [
              _hoisted_133,
              _hoisted_134,
              _createTextVNode(" # " + _toDisplayString(_ctx.savedItemList.length), 1)
            ]),
            _createElementVNode("span", _hoisted_135, [
              _hoisted_136,
              _hoisted_137,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalGross)), 1)
            ]),
            _createElementVNode("span", _hoisted_138, [
              _hoisted_139,
              _hoisted_140,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDiscAmount)), 1)
            ]),
            (_ctx.taxNames[0].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_141, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " ", 1),
                  _hoisted_142,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax1)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_143, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " ", 1),
                  _hoisted_144,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax2)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show)
              ? (_openBlock(), _createElementBlock("span", _hoisted_145, [
                  _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " ", 1),
                  _hoisted_146,
                  _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax3)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_147, [
              _hoisted_148,
              _hoisted_149,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.netTotal)), 1)
            ]),
            (_ctx.item.type != 'TRN')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  class: "p-col p-button-warning b-style",
                  icon: "pi pi-arrow-right",
                  label: "NEXT",
                  id: "nextBtn",
                  onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.openPaymentMethod(!_ctx.v$.$invalid))),
                  disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 4,
                  class: "p-col p-button-warning b-style",
                  icon: "pi pi-arrow-right",
                  label: "DONE",
                  onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.getProceededPayments([], _ctx.isToggled))),
                  disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
                }, null, 8, ["disabled"]))
          ])
        ]),
        _createVNode(_component_Dialog, {
          visible: _ctx.validationPopup,
          "onUpdate:visible": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.validationPopup) = $event)),
          style: { width: '600px' },
          header: "Confirm"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Close",
              icon: "pi pi-close",
              id: "closePopup",
              class: "p-button-danger",
              onClick: _ctx.closeValidationPopup
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_150, [
              _hoisted_151,
              _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Dialog, {
          visible: _ctx.removeProfileDialog,
          "onUpdate:visible": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.removeProfileDialog) = $event)),
          style: { width: '450px' },
          header: "Confirm"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "No",
              icon: "pi pi-times",
              class: "p-button-success",
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.removeProfileDialog = false))
            }),
            _createVNode(_component_Button, {
              label: "Yes",
              icon: "pi pi-check",
              class: "p-button-danger",
              onClick: _ctx.changeStatus
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _hoisted_152
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["fullscreen", "teleport", "page-only"]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
            dialogStatus: _ctx.paymentDialog,
            itemSource: _ctx.item.type,
            restriction: 'No',
            paymentOptionType: 'Cashier',
            cashPayment: this.cashPaymentOption,
            cardPayment: this.cardPaymentOption,
            payLater: this.payLaterOption,
            dialogTitle: 'Sale',
            customerID: this.item.profileID,
            customerName: this.state.selectedProfile,
            closeConfirmation: true,
        },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_ProfilerDialog, {
      profilerDetail: {
            status: this.profileStatus,
            profilerID: 0,
            statusType: this.statusType,
            dialogTitle: this.dialogTitle,
            currentUserID: this.currentUserID,
            profileTypes: this.profileTypes,
        },
      onUpdateProfilerStatus: _ctx.updateProfilerStatus
    }, null, 8, ["profilerDetail", "onUpdateProfilerStatus"])
  ], 64))
}